
<script>
import LightBox from "lightgallery.js"
import {onMount} from "svelte"


onMount(()=>{

 lightGallery(document.getElementById('lightgallery'));

})
</script>

<svlete:head>

<link type="text/css" rel="stylesheet" href="lightgallery/css/lightgallery.css"/>
</svlete:head>
  
<div>
    Hello.
</div>


<div id="lightgallery">
    <a href="http://placekitten.com/200/300">
        <img src="http://placekitten.com/200/300" />    
    </a>
    <a href="http://placekitten.com/300/300">
        <img src="http://placekitten.com/300/300" />
    </a>
  </div>